const DEFAULT_VEHICLE_COUNT = 9;
const MIN_ROUTE_DURATION_MS = 28000;
const ROUTE_DURATION_SPREAD_MS = 22000;

export const DECORATIVE_VEHICLE_PROFILES = Object.freeze([
    Object.freeze({
        driver: "Иванов Иван Иванович",
        trip: "SL-4082",
        vehicle: "Volvo FH · А123ВС 24",
        from: "moscow",
        to: "kazan",
        cargo: "consumerGoods",
        weight: 18,
        status: "inTransit",
        eta: "18:40",
    }),
    Object.freeze({
        driver: "Петров Пётр Сергеевич",
        trip: "SL-4127",
        vehicle: "КАМАЗ 54901 · М482КТ 16",
        from: "samara",
        to: "astana",
        cargo: "equipment",
        weight: 20,
        status: "onSchedule",
        eta: "21:15",
    }),
    Object.freeze({
        driver: "Сидоров Алексей Викторович",
        trip: "SL-3974",
        vehicle: "Scania R500 · Е716ОР 96",
        from: "astana",
        to: "almaty",
        cargo: "packaging",
        weight: 16,
        status: "inTransit",
        eta: "09:20",
    }),
    Object.freeze({
        driver: "Кузнецов Дмитрий Олегович",
        trip: "SL-4211",
        vehicle: "MAN TGX · В905УМ 54",
        from: "tashkent",
        to: "astana",
        cargo: "electronics",
        weight: 14,
        status: "checkpointPassed",
        eta: "14:05",
    }),
    Object.freeze({
        driver: "Смирнов Михаил Андреевич",
        trip: "SL-4056",
        vehicle: "DAF XF · Т338НА 38",
        from: "bishkek",
        to: "almaty",
        cargo: "components",
        weight: 19,
        status: "onSchedule",
        eta: "07:50",
    }),
    Object.freeze({
        driver: "Васильев Сергей Павлович",
        trip: "SL-4168",
        vehicle: "Mercedes Actros · К641РС 23",
        from: "novosibirsk",
        to: "astana",
        cargo: "food",
        weight: 17,
        status: "inTransit",
        eta: "16:30",
    }),
    Object.freeze({
        driver: "Попов Андрей Николаевич",
        trip: "SL-4019",
        vehicle: "SITRAK C7H · Н204ОВ 29",
        from: "urumqi",
        to: "almaty",
        cargo: "buildingMaterials",
        weight: 21,
        status: "checkpointPassed",
        eta: "11:10",
    }),
    Object.freeze({
        driver: "Морозов Роман Игоревич",
        trip: "SL-4193",
        vehicle: "Volvo FM · Р577ЕК 30",
        from: "harbin",
        to: "vladivostok",
        cargo: "equipment",
        weight: 15,
        status: "onSchedule",
        eta: "19:25",
    }),
    Object.freeze({
        driver: "Волков Артём Денисович",
        trip: "SL-4235",
        vehicle: "КАМАЗ 54901 · С812АВ 78",
        from: "beijing",
        to: "manzhouli",
        cargo: "components",
        weight: 20,
        status: "inTransit",
        eta: "22:00",
    }),
]);

function freezeRoute(points) {
    return Object.freeze(
        points.map((point) => Object.freeze(point))
    );
}

export const DECORATIVE_ROUTE_PATHS = Object.freeze([
    freezeRoute([
        [55.7558, 37.6173],
        [56.1291, 40.4075],
        [56.2965, 43.9361],
        [55.7963, 49.1088],
    ]),
    freezeRoute([
        [53.1959, 50.1008],
        [51.7682, 55.0969],
        [51.2293, 58.4752],
        [53.2144, 63.6246],
        [51.1694, 71.4491],
    ]),
    freezeRoute([
        [51.1694, 71.4491],
        [49.8064, 73.0855],
        [46.8489, 74.995],
        [43.2389, 76.8897],
    ]),
    freezeRoute([
        [41.2995, 69.2401],
        [42.3417, 69.5901],
        [43.2973, 68.2518],
        [49.8064, 73.0855],
        [51.1694, 71.4491],
    ]),
    freezeRoute([
        [42.8746, 74.5698],
        [43.2389, 76.8897],
    ]),
    freezeRoute([
        [55.0084, 82.9357],
        [53.3474, 83.7788],
        [52.2873, 76.9674],
        [51.1694, 71.4491],
    ]),
    freezeRoute([
        [43.8256, 87.6168],
        [44.1664, 86.0494],
        [44.1979, 80.4167],
        [43.2389, 76.8897],
    ]),
    freezeRoute([
        [45.8038, 126.535],
        [44.5514, 129.6324],
        [43.1155, 131.8855],
    ]),
    freezeRoute([
        [39.9042, 116.4074],
        [41.5737, 120.4494],
        [43.6529, 122.2434],
        [47.3556, 123.9182],
        [49.5978, 117.3787],
    ]),
]);

function normalizeRandomValue(value) {
    if (!Number.isFinite(value)) {
        return 0;
    }

    return Math.min(Math.max(value, 0), 0.999999);
}

function calculateSegmentLength(start, end) {
    const averageLatitude = (start[0] + end[0]) / 2;
    const latitudeDistance = end[0] - start[0];
    const longitudeDistance =
        (end[1] - start[1]) *
        Math.cos((averageLatitude * Math.PI) / 180);

    return Math.hypot(
        latitudeDistance,
        longitudeDistance
    );
}

function resolveRouteProgress(vehicle, elapsedMs) {
    const safeElapsedMs = Math.max(0, elapsedMs);
    const cyclePosition =
        (vehicle.phase +
            safeElapsedMs / vehicle.routeDurationMs) %
        2;

    return cyclePosition <= 1
        ? cyclePosition
        : 2 - cyclePosition;
}

function interpolateRoute(path, progress) {
    if (progress <= 0) {
        return [...path[0]];
    }

    if (progress >= 1) {
        return [...path[path.length - 1]];
    }

    const segmentLengths = path
        .slice(0, -1)
        .map((point, index) =>
            calculateSegmentLength(point, path[index + 1])
        );

    const routeLength = segmentLengths.reduce(
        (total, segmentLength) => total + segmentLength,
        0
    );

    let remainingDistance = routeLength * progress;

    for (
        let segmentIndex = 0;
        segmentIndex < segmentLengths.length;
        segmentIndex += 1
    ) {
        const segmentLength = segmentLengths[segmentIndex];

        if (remainingDistance > segmentLength) {
            remainingDistance -= segmentLength;
            continue;
        }

        const start = path[segmentIndex];
        const end = path[segmentIndex + 1];
        const segmentProgress =
            segmentLength === 0
                ? 0
                : remainingDistance / segmentLength;

        return [
            start[0] +
                (end[0] - start[0]) * segmentProgress,
            start[1] +
                (end[1] - start[1]) * segmentProgress,
        ];
    }

    return [...path[path.length - 1]];
}

export function createDecorativeFleet({
    count = DEFAULT_VEHICLE_COUNT,
    random = Math.random,
    routes = DECORATIVE_ROUTE_PATHS,
} = {}) {
    if (!Number.isInteger(count) || count < 0) {
        throw new RangeError(
            "Decorative vehicle count must be a non-negative integer"
        );
    }

    if (typeof random !== "function") {
        throw new TypeError(
            "Decorative fleet random source must be a function"
        );
    }

    if (!Array.isArray(routes) || routes.length === 0) {
        throw new TypeError(
            "Decorative fleet requires at least one route"
        );
    }

    return Array.from({length: count}, (_, index) => {
        const phase = normalizeRandomValue(random()) * 2;
        const routeDurationMs =
            MIN_ROUTE_DURATION_MS +
            normalizeRandomValue(random()) *
                ROUTE_DURATION_SPREAD_MS;

        return Object.freeze({
            id: `decorative-vehicle-${index + 1}`,
            path: routes[index % routes.length],
            phase,
            profile:
                DECORATIVE_VEHICLE_PROFILES[
                    index %
                        DECORATIVE_VEHICLE_PROFILES.length
                ],
            routeDurationMs,
        });
    });
}

export function getDecorativeVehiclePosition(
    vehicle,
    elapsedMs
) {
    return interpolateRoute(
        vehicle.path,
        resolveRouteProgress(vehicle, elapsedMs)
    );
}
